var map = {
	"./gameUpdatesService.js": 6009,
	"./gameUpdatesUtility.js": 4298,
	"./layoutLibraryI18nService.js": 5078,
	"./notificationStreamService.js": 8892,
	"./notificationStreamUtility.js": 1294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3545;